import React, { useEffect, useMemo, useState } from 'react'

// UI

import EditableTable from '@/components/Table/EditableTable'
import { InputCell } from '@/components/Table/components/Cell'
import { TooltipCell } from '@/components/Table/components/Cell/ToolTipCell'
import {
  Button,
  Checkbox,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

//Hooks
//Constant
import { createColumnHelper } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

const ECCNDetailModal = ({ quotationDetailIndex, ECCNDetail, onClose, handleUpdateECCNDetail, canEdit }) => {
  const [internalECCNDetail, setInternalECCNDetail] = useState(ECCNDetail)

  const columnHelper = createColumnHelper()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const handleUpdateTable = (rowIndex, columnId, value) => {
    setInternalECCNDetail((prevECCN) =>
      prevECCN.map((row, index) => (index === rowIndex ? { ...row, [columnId]: value } : row))
    )
    //
  }

  const closeModal = () => {
    onClose()

    if (canEdit && handleUpdateECCNDetail) {
      handleUpdateECCNDetail(internalECCNDetail)
    }
  }

  const questionnaireColumnDef = useMemo(
    () => [
      columnHelper.display({
        id: 'index',
        header: () => <span>{t('VENDOR_UPLOAD_PAGE_DATA_TABLE_INDEX')}</span>,
        cell: ({ row: { index } }) => <TooltipCell text={index + 1} />,
      }),
      columnHelper.accessor('description', {
        header: () => <span>{t('VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY')}</span>,
        cell: ({ getValue }) => <span>{t(getValue())}</span>,
      }),
      columnHelper.display({
        header: () => <span>{t('VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_YES')}</span>,
        id: 'selectYes',
        cell: ({ getValue, row: { index, original }, column: { id }, table }) => {
          const [selected, setSelected] = useState(original?.selected || false)
          const disabled = table.options.meta?.disabled

          const onChange = (e) => {
            setSelected(e.target.checked)
            const newValue = e.target.checked
            table.options.meta?.updateData(index, 'selected', newValue)
            //React-table v8 will replace . with _
            // table.options.meta?.updateData(index, id.replace('__', '._'), newValue)
          }

          useEffect(() => {
            if (original?.selected) {
              setSelected(true)
            }
          }, [original?.selected])

          return (
            <Checkbox
              borderColor={'gray.400'}
              isChecked={selected || false}
              value={selected || false}
              onChange={onChange}
              isDisabled={disabled}
            />
          )
        },
      }),
      columnHelper.display({
        header: () => <span>{t('VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_NO')}</span>,
        id: 'selectNo',
        cell: ({ getValue, row: { index, original }, column: { id }, table }) => {
          const [selected, setSelected] = useState(!original?.selected || false)
          const disabled = table.options.meta?.disabled

          const onChange = (e) => {
            setSelected(e.target.checked)
            const newValue = e.target.checked
            table.options.meta?.updateData(index, 'selected', !newValue)
          }

          useEffect(() => {
            if (original?.selected) {
              setSelected(false)
            }
          }, [original?.selected])

          return (
            <Checkbox
              borderColor={'gray.400'}
              isChecked={selected || false}
              value={selected || false}
              onChange={onChange}
              isDisabled={disabled}
            />
          )
        },
      }),

      columnHelper.accessor('productName', {
        header: () => <span>{t('VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_PRODUCT_NAME')}</span>,
        cell: (cell) => <InputCell {...cell} />,
      }),
    ],
    [columnHelper]
  )
  return (
    <Modal isOpen={true} onClose={closeModal} size="xl">
      <ModalOverlay />
      <ModalContent maxW={'90%'}>
        <ModalHeader>{t('VENDOR_UPLOAD_PAGE_DATA_TABLE_ECCN_DETAIL')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <EditableTable
            textAlign={'left'}
            columnDef={questionnaireColumnDef}
            data={internalECCNDetail ?? []}
            tableWidth="100%"
            disabled={!canEdit}
            updateData={handleUpdateTable}
          />
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default ECCNDetailModal
